<template>
  <input
    class="form-control"
    type="text"
    :value="formattedValue"
    @input="handleInput"
    @keydown="blockNonNumeric"
    inputmode="numeric"
    placeholder="0.00"
  />
</template>

<script>
export default {
  props: {
    modelValue: {
      type: [Number, String],
      default: 0
    }
  },
  data() {
    return {
      // rawDigits siempre reflejará modelValue*100 como dígitos
      rawDigits: ''
    };
  },
  computed: {
    formattedValue() {
      // del rawDigits armamos la vista “int.dec”
      const digits = this.rawDigits.replace(/\D/g, '');
      const len = digits.length;
      const intPart = digits.slice(0, Math.max(len - 2, 0)) || '0';
      const decimalPart = digits.slice(-2).padStart(2, '0');
      return `${intPart}.${decimalPart}`;
    }
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(val) {
        // cuando modelValue cambie, recalculamos rawDigits
        // multiplicamos por 100 y quitamos todo no numérico
        const num = parseFloat(val) || 0;
        this.rawDigits = String(Math.round(num * 100));
      }
    }
  },
  methods: {
    handleInput(e) {
      // usuario teclea: guardamos esos dígitos
      const digits = e.target.value.replace(/\D/g, '').slice(0, 15);
      this.rawDigits = digits || '0';
      // emitimos el valor numérico con decimales
      const len = this.rawDigits.length;
      const intPart = this.rawDigits.slice(0, Math.max(len - 2, 0)) || '0';
      const decimalPart = this.rawDigits.slice(-2).padStart(2, '0');
      this.$emit('update:modelValue', parseFloat(`${intPart}.${decimalPart}`));
    },
    blockNonNumeric(e) {
      const allowed = [
        'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End'
      ];
      if (allowed.includes(e.key) || /^[0-9]$/.test(e.key)) return;
      e.preventDefault();
    }
  }
};
</script>